<template>
  <div id="app">
    <step-transition>
      <component
        :is="currentStep"
        :key="currentStep">
      </component>
    </step-transition>
  </div>
</template>

<script>
import StepTransition from '@shared/components/StepTransition'
import { mapGetters } from 'vuex'
import scrollHelper from '@shared/utils/scrollHelper'

import Intro from './views/Intro'
import ArrivalGame from './views/ArrivalGame'
import DepartureGame from './views/DepartureGame'
import Outro from './views/Outro'

export default {
  name: 'App',
  components: {
    StepTransition,
    intro: Intro,
    arrivalGame: ArrivalGame,
    departureGame: DepartureGame,
    outro: Outro
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  mounted () {
    this.$store.dispatch('init')
    scrollHelper.init()
  }
}
</script>

<style lang="scss">
  @import "../shared/styles/globals";
</style>
